import { FetchPolicyError, fetchWithPolicy } from '../../../lib/api/fetchPolicy'
import { API_BASE } from '../constants'

const withErrorCause = (message: string, cause: unknown): Error => {
  const symptomError = new Error(message) as Error & { cause?: unknown }
  symptomError.cause = cause
  return symptomError
}

export const requestSetupApi = async ({
  path,
  init,
  fallbackError,
}: {
  path: string
  init?: RequestInit
  fallbackError: string
}) => {
  try {
    return await fetchWithPolicy({
      request: `${API_BASE}${path}`,
      init,
    })
  } catch (error) {
    if (error instanceof FetchPolicyError) {
      throw withErrorCause(fallbackError, error)
    }
    throw error
  }
}
